export const getFormattedSum = (value: number) => {
  if (typeof value !== 'number') {
    value = Number(value);

    if (isNaN(value)) {
      return '0';
    }
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
